// extracted by mini-css-extract-plugin
export var deleteIcon = "_p6-5";
export var deleteOption = "_p6-3";
export var divider = "_p6-2";
export var downloadIcon = "_p6-4";
export var drawer = "_p6-0";
export var drawerFooter = "_p6-6";
export var drawerOpen = "_p6-1";
export var highlighted = "_p6-7";
export var lighterHighlight = "_p6-8";